import { styled } from "@mui/system";

const ProductPricingContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: theme.spacing(0, 1),
  alignItems: "center",
  flexWrap: "wrap",
  color: theme.palette.grey[700],
}));

export default ProductPricingContainer;
